import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TeachersUIHelpers";

const TeachersUIContext = createContext();

export function useTeachersUIContext() {
  return useContext(TeachersUIContext);
}

export const TeachersUIConsumer = TeachersUIContext.Consumer;

export function TeachersUIProvider({ teachersUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewTeacherPage: teachersUIEvents.openNewTeacherPage,
    openEditTeacherPage: teachersUIEvents.openEditTeacherPage
  };

  return (
    <TeachersUIContext.Provider value={value}>
      {children}
    </TeachersUIContext.Provider>
  );
}